module.exports = {
  //provide realtime clock for performance measurement
  now: function now() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      return performance.now();
    }
    return Date.now();
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/lib/realclock/browserClock.js
// module id = 723
// module chunks = 0